import type {
	Cart,
	ShippingMethod,
	ShippingMethodPagedQueryResponse,
} from "@commercetools/platform-sdk";
import { fetchFromCTWithSession } from "./frontend-session";

export const getShippingMethodsForCart = async (
	cart: Cart,
): Promise<ShippingMethod[]> => {
	if (!process.env.GATSBY_COMMERCETOOLS_PROJECT_KEY)
		throw new Error("Missing GATSBY_COMMERCETOOLS_PROJECT_KEY");
	if (!cart.country) throw new Error("Missing cart country");
	if (!cart.id) throw new Error("Missing cart id");

	try {
		const res = await fetchFromCTWithSession<ShippingMethodPagedQueryResponse>(
			`/${process.env.GATSBY_COMMERCETOOLS_PROJECT_KEY}/shipping-methods/matching-cart-location?country=${cart.country}&cartId=${cart.id}&expand=zoneRates[*].zone`,
		);

		return res.data?.results ?? [];
	} catch {
		return [];
	}
};
